export default __webpack_public_path__ + "static/media/head04_zh_tw_pc.ea8655a2.png";